export default "__VITE_ASSET__70o0qFFf__"